import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const Container = styled.div`
  display: grid; 
  gap: clamp(0.75rem, 1.5vw, 1rem); 
  height: 100%;
  grid-template-columns: repeat(auto-fit, minmax(min(100%, 300px), 1fr)); 
  grid-template-rows: auto auto 1fr; 
  grid-template-areas: 
    "Header Header Header"
    "CardPrimary CardSecondary CardTertiary"
    "Extrato Extrato Extrato";
  width: 100%;
  padding: clamp(0.75rem, 2vw, 1.25rem);
  
  @media (max-width: 992px) {
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    gap: clamp(0.5rem, 1vw, 0.75rem);
  }
  
  @media (max-width: 768px) {
    grid-template-areas: 
      "Header"
      "CardPrimary"
      "CardSecondary"
      "CardTertiary"
      "Extrato";
    grid-template-columns: 1fr;
    padding: clamp(0.5rem, 1vw, 0.75rem);
  }
`;

export const BannerContainer = styled.div`
  grid-area: Header;
  width: 100%;
`;

export const ExtratoContainer = styled.div`
  grid-area: Extrato;
  width: 100%;
  overflow: auto;
  max-height: 100%;
  border-radius: 10px;
  
  @media (max-width: 768px) {
    max-height: 400px;
  }
`;

export const HeaderContainer = styled.div`
  padding: clamp(0.5rem, 1vw, 0.625rem);
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  
  @media (max-width: 576px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.5rem;
  }
`;

export const ExtratoLink = styled.div`
  display: flex;
  align-items: center;
  gap: clamp(0.25rem, 0.5vw, 0.3125rem);
`;

export const Subtitle = styled.span`
  white-space: pre-wrap;
  font-size: clamp(0.75rem, 1.25vw, 1rem);
  color: ${props => props.theme.colors.text};
  transition: 200ms;
  font-weight: 700;
`;

export const StyledLink = styled(Link)`
  text-decoration: none;
  color: ${props => props.theme.colors.primary};
  display: block;
  width: 100%;
  height: 100%;
  padding: clamp(0.375rem, 0.75vw, 0.5rem);
  transition: background-color 0.2s ease;
  
  &:hover {
    background-color: rgba(0, 0, 0, 0.05);
  }
`;